<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="add-pushRule-dialog"
  >
    <wechat-server-form
      :form-data="formData"
      ref="outform"
      @submit="submit"
    ></wechat-server-form>
  </sliderBarDialogShell>
</template>

<script>
import wechatServerForm from "@/components/sys/wechat-server/wechatServerForm";
import {updateWechatServer} from "@/api/sys/wechatServer/wechatServer";

export default {
  name: "editDialog",
  components: {
    wechatServerForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    formData:{
      type: Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {
      title: '编辑服务器',
    }
  },
  watch:{
    dialogShow(newValue){
      if(newValue && this.formData.id){
        setTimeout(() => {
          this.$refs.outform && this.$refs.outform.assigen(this.formData);
        },200);
      }
    },
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        ...form,
      }
      updateWechatServer(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '修改成功',
            type: 'success',
          });
          this.$emit('edit-success');
        }else{
          this.$message.error(data.msg);
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style scoped>

</style>
